import jsCookie from 'js-cookie';
import rsaConfig from "../rsaConfig";
import {oauthTokenAPI,mobileLogin,logoutAPI} from '@/modle/api.js';
import store from "../store";
import tokenUtil from "@/util/tokenUtil";
import splitUrlUtil from "../util/splitUrlUtil.js";

let appId = 'wxadcc1ac80b310680';//appId  wxadcc1ac80b310680
const query = splitUrlUtil.getUrlParams();  
if(query["appId"]) {
    appId = query["appId"];
}

export default {
    setToken(access_token, refresh_token, ucode, token_type, expires_in) {
        expires_in = new Date(new Date().getTime() + (expires_in - 600) * 1000);
        // expires_in = 30;
        jsCookie.set("token_" + rsaConfig.clientId, access_token, {expires: expires_in});
        jsCookie.set("refresh_token_" + rsaConfig.clientId, refresh_token, {expires: 30});
        jsCookie.set("ucode_" + rsaConfig.clientId, ucode, {expires: expires_in});
        jsCookie.set("token_type_" + rsaConfig.clientId, token_type, {expires: expires_in});
    },
    getToken() {
        let token = jsCookie.get("token_" + rsaConfig.clientId);
        let token_type = jsCookie.get("token_type_" + rsaConfig.clientId);
        if (token !== undefined) {
            return token_type + " " + token;
        }
        return ''
    },
    getRefreshToken() {
        return jsCookie.get("refresh_token_" + rsaConfig.clientId);
    },
    clearToken() {
        jsCookie.remove("token_" + rsaConfig.clientId);
        jsCookie.remove("ucode_" + rsaConfig.clientId);
        jsCookie.remove("token_type_" + rsaConfig.clientId);
        jsCookie.remove("refresh_token_" + rsaConfig.clientId);
    },
    getUcode() {
        let ucode = jsCookie.get("ucode_" + rsaConfig.clientId);
        return ucode;
    },
    // 刷新登录
    async refreshToken(api) {
       
        try {
            console.log('刷新token',store.state.login_source);
            if(store.state.login_source=="mobile") 
            {
                
                console.log("手机号登录,刷新token")
                const UserId = jsCookie.get("UserId");
                let res = await mobileLogin({
                    // grant_type: "password",
                    // auth_type: 'wecom',
                    // appCode: appId,
                    // username: jsCookie.get("cid") || '',
                    // refresh_token: this.getRefreshToken()
                    grant_type: "password",
                    password:'',  
                    appCode: appId, 
                    scope: "all",
                    auth_type: "wemp",
                    login_source:'mobile', 
                    openId: jsCookie.get("openId") || '',
                });
                
                console.log(res)
                this.setToken(
                    res.data.value,
                    res.data.refreshToken.value || '',
                    res.data.additionalInformation.ucode,
                    res.data.tokenType,
                    res.data.expiresIn
                );
                store.commit("changeLogin", true);
                window.location.reload();
                
            }
            else
            {
                const UserId = jsCookie.get("UserId");
                let res = await oauthTokenAPI({
                    grant_type: "refresh_token",
                    auth_type: 'wecom',
                    userId: UserId,
                    username: jsCookie.get("cid") || '',
                    refresh_token: this.getRefreshToken()
                })
                
                console.log(res)
                this.setToken(
                    res.data.value,
                    res.data.refreshToken.value || '',
                    res.data.additionalInformation.ucode,
                    res.data.tokenType,
                    res.data.expiresIn
                );
                store.commit("changeLogin", true);
                window.location.reload();
            }
            
            
        } catch (error) {
            console.log(error);
        }
    },
    // 刷新登录
    async refreshTokenVcode() {
        try {
            const query = splitUrlUtil.getUrlParams();
            let res = await oauthTokenAPI({
                grant_type: "refresh_token",
                appCode: query['appCode']?query['appCode']:'',
                auth_type: 'wemp',
                refresh_token: this.getRefreshToken(),
                openId: jsCookie.get("openId")
            })
            console.log(res)
            if (Number(res.code) === 0) {
                this.setToken(
                    res.data.value,
                    res.data.refreshToken.value || '',
                    res.data.additionalInformation.ucode,
                    res.data.tokenType,
                    res.data.expiresIn
                );
                store.commit("changeLogin", true);
                window.location.reload();
            } else {
                this.clearToken();
                let url = window.location.origin;
                let pathname = window.location.pathname; 
                // console.log('query---', query)
                let placeCode = query['appCode'] ? query['appCode'] : '';
                if (placeCode) {
                    window.location.href = `${url}${pathname}?appCode=${placeCode}`;
                } else {
                    window.location.href = `${url}${pathname}`;
                }
            }

        } catch (error) {
            console.log(error);
        }
    }
}



// WEBPACK FOOTER //
// ./src/util/tokenUtil.js